import {useSearchParams} from 'react-router-dom';
import {sha256} from 'js-sha256';
import {setUserToken} from '../../../../utils/api';

// The Luogo and Iniziativa pages are separate routes, each with its own survey id params.
export const useLuoghi2025Auth = (surveyParamNames: string[]) => {
    const [searchParams] = useSearchParams();

    const container = searchParams.get('container_id');
    const uoaId = searchParams.get('uoa_id');
    const hashKey = searchParams.get('key');
    const token = searchParams.get('token');
    const surveyIds: Record<string, string | null> = Object.fromEntries(
        surveyParamNames.map((name) => [name, searchParams.get(name)]),
    );

    const hashKeyLocal = sha256(process.env.REACT_APP_HASH_KEY_FSV || '');

    if (token) {
        setUserToken(token);
    }

    const isAuthorized = !!(
        container &&
        uoaId &&
        hashKey === hashKeyLocal &&
        surveyParamNames.every((name) => surveyIds[name])
    );

    return {container, uoaId, surveyIds, isAuthorized};
};
